import humps from 'humps'
import { defineStore } from 'pinia'
import { readonly, computed, ref } from 'vue'

export const useDailyRewardStore = defineStore('dailyRewardStore', () => {
  const dailyRewardInfo = ref<any>({})

  // getters
  const getDailyRewardInfo = computed(() => readonly(dailyRewardInfo.value))

  // actions
  async function fetchDailyRewardInfo() {
    const res = await this.$nuxt.$dailyRewardService.getDailyRewardInfo()
    dailyRewardInfo.value = humps.camelizeKeys(res)
  }

  return {
    dailyRewardInfo,
    getDailyRewardInfo,
    fetchDailyRewardInfo,
  }
})
